import Select from "react-select";
import { IoMdArrowDropdown, IoMdClose } from "react-icons/io";
import { Controller } from "react-hook-form";

export const MultiSelectDropDown = ({
  name,
  option,
  placeholder,
  label,
  control,
  rules,
  isRequired,
  labelStyle,
  value: initialValue,
  disabled = false,
  hasSearched = false,
  onSelectionChange,
}) => {
  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      minHeight: 28,
      padding: 4,
      backgroundColor: disabled ? "#e9ecef" : "white",
      border: state.selectProps.error
        ? "1px solid #ef4444"
        : "1px solid #e9ecef",
      borderColor: state.isFocused
        ? "#3b82f6"
        : state.selectProps.error
        ? "#ef4444"
        : "#e9ecef",
      boxShadow: state.isFocused
        ? state.selectProps.error
          ? "0 0 0 4px #FF808066"
          : "0 0 0 4px #63AAFF80"
        : "none",
      "&:hover": {
        borderColor: state.selectProps.error
          ? "#ef4444"
          : state.isFocused
          ? "#3b82f6"
          : "#e9ecef",
      },
    }),
    option: (provided, state) => ({
      ...provided,
      maxHeight: 200,
      backgroundColor: state.isSelected
        ? "#9CA3AF"
        : state.isFocused
        ? "#D1D5DB"
        : "white",
      color: state.isSelected ? "white" : "black",
      padding: "10px",
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: 200,
    }),
    valueContainer: (provided) => ({
      ...provided,
      padding: "0 8px",
    }),
    multiValue: (provided) => ({
      ...provided,
      backgroundColor: "#D1D5DB",
      borderRadius: "4px",
    }),
    multiValueLabel: (provided) => ({
      ...provided,
      color: "#374151",
      padding: "2px",
      fontSize: "0.875rem",
    }),
    multiValueRemove: (provided) => ({
      ...provided,
      color: "#9CA3AF",
      ":hover": {
        backgroundColor: "#D1D5DB",
        color: "#D1D5DB",
      },
    }),
  };

  const MultiValue = ({ data, index, removeProps, selectProps }) => {
    const selectedItems = selectProps.value;
    const firstItem = selectedItems[0];
    const remainingCount = selectedItems.length - 1;

    return (
      <div className="flex items-center">
        {index === 0 && (
          <>
            <div className=" text-white bg-gray-400 rounded-full px-2 py-1 text-xs font-semibold mr-2">
              {firstItem.label}
            </div>
            {remainingCount > 0 && (
              <div className="text-xs text-gray-500">+{remainingCount}</div>
            )}
          </>
        )}
      </div>
    );
  };

  const ClearIndicator = (props) => {
    const {
      innerProps: { ref, ...restInnerProps },
    } = props;
    return (
      <div {...restInnerProps} ref={ref} className="text-md cursor-pointer">
        <IoMdClose />
      </div>
    );
  };

  return (
    <div>
      <label
        className={`${
          labelStyle
            ? labelStyle
            : "block text-input-label text-sm font-bold mb-1.5"
        }`}
        htmlFor={name}
      >
        {label}
        {isRequired && " *"}
      </label>
      <Controller
        name={name}
        control={control}
        defaultValue={initialValue || []}
        rules={rules}
        render={({ field, fieldState: { error } }) => {
          const selectedItems = field.value || initialValue;

          const onChangeDropdown = (field, selectedOption) => {
            if (hasSearched) {
              if (onSelectionChange) {
                onSelectionChange(selectedOption);
              }
            }

            // If "Select All" is selected, select all available options
            if (
              selectedOption.some((option) => option.value === "select-all")
            ) {
              field.onChange(option);
            } else {
              field.onChange(selectedOption);
            }
          };

          // Conditionally add the "Select All" option only if there are available options
          const allOptions =
            option.length > 1
              ? [{ label: "Select All", value: "select-all" }, ...option]
              : [...option];

          return (
            <>
              <Select
                isMulti
                className="text-gray-700 font-roboto text-sm whitespace-nowrap z-30"
                options={allOptions}
                styles={customStyles}
                placeholder={placeholder}
                isDisabled={disabled}
                isClearable={!isRequired}
                hideSelectedOptions={false}
                onChange={(selectedOption) => {
                  if (
                    selectedOption.some(
                      (option) => option.value === "select-all"
                    )
                  ) {
                    field.onChange(option);
                  } else {
                    onChangeDropdown(field, selectedOption);
                  }
                }}
                value={selectedItems}
                error={error ? true : false}
                components={{
                  IndicatorSeparator: () => null,
                  ClearIndicator,
                  DropdownIndicator: () => (
                    <div className="text-lg">
                      <IoMdArrowDropdown />
                    </div>
                  ),
                  MultiValue,
                }}
              />
              {error && (
                <p className="text-red-500 text-sm pt-1 font-roboto font-thin">
                  {error.message}
                </p>
              )}
            </>
          );
        }}
      />
    </div>
  );
};
